<template>
    <a-card type="inner" size="small">
        <a-form-model :model="formData" :rules="rules" ref="ruleForm">
            <a-form-model-item :label="'Upload ' + category">
                <a-upload
                    :file-list="fileList"
                    :remove="handleRemove"
                    :before-upload="beforeUpload"
                    @change="handleChange"
                >
                    <a-button>
                        <a-icon type="upload" /> Select File
                    </a-button>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item>
                <a-row type="flex" justify="center" align="top">
                    <a-col>
                        <a-space>
                            <a-button
                                type="primary"
                                html-type="submit"
                                :loading="processing"
                                :disabled="processing"
                                @click="handleSubmit"
                                >Submit</a-button>
                            <a-button
                                @click="handleClose"
                                :loading="processing"
                                :disabled="processing"
                                >Tutup</a-button>
                        </a-space>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model>
    </a-card>
</template>

<script>
export default {
    props: {
        category: {
            type: String
        },
        hash: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            processing: false,
            formData: {},
            fileList: [],
        }
    },
    methods: {
        handleRemove(file) {
            const index = this.fileList.indexOf(file)
            const newFileList = this.fileList.slice()
            newFileList.splice(index, 1)
            this.fileList = newFileList
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            return false
        },
        handleChange(info) {
            let fileList = [...info.fileList]

            if (fileList.length > 1) {
                fileList = fileList.slice(-1)

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url
                    }
                    return file
                });
                this.fileList = fileList
            }
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.$refs.ruleForm.validate(valid => {
                if(valid){
                    this.processing = true

                    let promise

                    var data = new FormData()

                    for (var k in this.formData) {
                        if (this.formData.hasOwnProperty(k)) {
                            data.append(k, this.formData[k])
                        }
                    }

                    data.append("attachment", this.fileList[0])
                    data.append("step_id", this.hash)
                    data.append("category", this.category)

                    promise = this.$http.post(
                        this.routeUri('api.project-management.action-step.upload'),
                        data
                    )

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false))
                }else{
                    return false
                }
            })
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
    }
}
</script>
